import React from "react";
import { Link } from "react-router-dom";
import Reveal from "./reveal";
import { postDetails } from "../content/posts";

/** Blog tile. `post` = [slug, category, title, description] from data.js. */
export default function PostCard({ post, index = 0, delay = 0 }) {
  const [slug, category, title, desc] = post;
  return (
    <Reveal className="post" delay={delay}>
      <div className={`post-img post-${(index % 3) + 1}`}><span>{category}</span></div>
      <div className="post-body">
        <small>{postDetails[slug]?.readTime}</small>
        <h3>{title}</h3>
        <p>{desc}</p>
        <Link to={`/blog/${slug}`}>Read Article</Link>
      </div>
    </Reveal>
  );
}
